<!-- Shared header template -->
<ng-template #headerTemplate let-doctorText>
  <div class="tw-bg-orange-400 tw-rounded-b-6 tw-overflow-hidden tw-px-6 tw-pt-10 tw-pb-6">
    <div
      class="tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-rounded-3 tw-h-10 tw-w-10 tw-shadow-z1"
      (click)="goBack()">
      <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
    </div>

    <div class="tw-flex tw-items-center tw-gap-1 bg-white-overlay tw-rounded-4 tw-pl-1 tw-pr-3 tw-py-1 tw-mt-6 tw-w-fit">
      <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'check_circle'"></cs-icon>
      <span class="tw-font-lexend tw-font-bold tw-text-300 tw-text-white">
        @if (isCodOrder) {
          <span i18n="@@isotretinoinOrderReceived">Order received</span>
        } @else {
          <span i18n="@@paymentReceived">Payment received</span>
        }
      </span>
    </div>

    <p class="tw-font-lexend tw-font-bold tw-text-500 tw-text-white tw-mt-6">
      {{ userName }}, <span i18n="@@safetyCheckTitleSuffix">one last step before we ship</span>
    </p>

    <div class="tw-flex tw-items-center tw-gap-2.5 bg-white-overlay tw-rounded-2 tw-px-3 tw-py-2 tw-mt-3">
      <img
        [src]="doctorImage"
        class="tw-w-14 tw-h-14 tw-rounded-full tw-object-contain tw-shrink-0"
        alt="Doctor" />
      <ng-container [ngTemplateOutlet]="doctorText"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #questionDoctorText>
  <p class="tw-text-200 tw-text-white tw-font-body">
    <span class="tw-font-bold" i18n="@@treatmentContainsMedication">Your treatment contains Isotretinoin.</span>
    <span> </span><span i18n="@@pleaseAnswerBeforeContinuing">Please answer before continuing.</span>
  </p>
</ng-template>

<ng-template #consentDoctorText>
  <p class="tw-text-200 tw-text-white tw-font-body">
    <span class="tw-font-bold" i18n="@@treatmentContainsIsotretinoin">Your treatment contains Isotretinoin.</span>
    <span> </span><span i18n="@@isotretinoinConsentDesc">It is a highly effective acne treatment that needs your consent before it's on the way.</span>
  </p>
</ng-template>

@if (currentView === 'question') {
<div class="tw-bg-gray-100 tw-min-h-screen tw-flex tw-flex-col">
  <ng-container *ngTemplateOutlet="headerTemplate; context: { $implicit: questionDoctorText }"></ng-container>

  <div class="tw-px-6 tw-pt-6 tw-flex tw-flex-col tw-gap-5">
    <p class="tw-text-100 tw-text-gray-500 tw-tracking-wider tw-uppercase tw-font-body" i18n="@@safetyCheckLabel">
      Safety Check
    </p>

    <div class="tw-flex tw-flex-col tw-gap-5">
      <p class="tw-text-400 tw-text-gray-800 tw-font-body tw-font-medium" i18n="@@pregnancyQuestion">
        Are you currently pregnant, planning a pregnancy, or breastfeeding?
      </p>

      <div class="tw-flex tw-flex-col tw-gap-2">
        <div class="tw-rounded-2 tw-shadow-z1 tw-px-4 tw-py-3 tw-bg-gray-75" (click)="selectOption('I am pregnant')">
          <span class="tw-font-body tw-font-semibold tw-text-300 tw-text-teal-600" i18n="@@optionPregnant">I am pregnant</span>
        </div>
        <div class="tw-rounded-2 tw-shadow-z1 tw-px-4 tw-py-3 tw-bg-gray-75" (click)="selectOption('Planning pregnancy in next 6 months')">
          <span class="tw-font-body tw-font-semibold tw-text-300 tw-text-teal-600" i18n="@@optionPlanningPregnancy">Planning pregnancy in next 6 months</span>
        </div>
        <div class="tw-rounded-2 tw-shadow-z1 tw-px-4 tw-py-3 tw-bg-gray-75" (click)="selectOption('I am a new mom & breastfeeding')">
          <span class="tw-font-body tw-font-semibold tw-text-300 tw-text-teal-600" i18n="@@optionNewMom">I am a new mom &amp; breastfeeding</span>
        </div>
        <div class="tw-rounded-2 tw-shadow-z1 tw-px-4 tw-py-3 tw-bg-gray-75" (click)="selectOption('None')">
          <span class="tw-font-body tw-font-semibold tw-text-300 tw-text-teal-600" i18n="@@optionNone">None</span>
        </div>
      </div>
    </div>
  </div>
</div>

@if (showPopup) {
  <div class="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-end bg-dark-overlay" (click)="closePopup()">
    <div
      class="tw-bg-gray-75 tw-rounded-t-6 tw-px-6 tw-py-9 tw-w-full tw-relative tw-flex tw-flex-col tw-gap-8"
      (click)="$event.stopPropagation()">

      <div
        class="tw-absolute tw-top-4 tw-right-4 tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center tw-cursor-pointer"
        (click)="closePopup()">
        <cs-icon class="tw-h-5 tw-w-5 tw-text-gray-500" [iconName]="'close'"></cs-icon>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-4">
        <img src="/assets/icons/teal-tick-circle.svg" class="tw-h-10 tw-w-10" alt="" />
        <div class="tw-flex tw-flex-col tw-gap-1">
          <p class="tw-font-lexend tw-font-bold tw-text-600 tw-text-gray-800" i18n="@@treatmentUpdatedTitle">
            We've updated your treatment
          </p>
          <div class="tw-font-body tw-font-medium tw-text-300 tw-text-gray-500">
            <p i18n="@@treatmentUpdatedBody">
              As you have updated your pregnancy status, we have replaced Isotretinoin with Azithromycin as per the safety guidelines.
            </p>
            <p class="tw-mt-4" i18n="@@treatmentUpdatedSafe">
              Your new regimen has been carefully chosen to ensure it is safe for you at this stage.
            </p>
          </div>
        </div>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-3">
        @if (showWhyRemoved) {
          <div class="tw-bg-gray-100 tw-rounded-1 tw-px-2 tw-py-3 tw-text-200">
            <p class="tw-font-body tw-font-bold tw-italic tw-text-teal-600" i18n="@@whyIsotretinoinRemoved">
              Why Isotretinoin was removed?
            </p>
            <p class="tw-font-body tw-text-gray-500 tw-mt-1" i18n="@@whyIsotretinoinRemovedBody">
              Isotretinoin is not safe during pregnancy, breastfeeding, or while planning conception. It can cause severe birth defects and serious harm to a developing baby, even with a single dose. To protect your health and your baby's, we have removed it from your treatment.
            </p>
          </div>
        } @else {
          <p
            class="tw-font-body tw-font-bold tw-italic tw-text-200 tw-text-teal-600 tw-cursor-pointer"
            (click)="toggleWhyRemoved()"
            i18n="@@whyIsotretinoinRemoved">
            Why Isotretinoin was removed?
          </p>
        }
        <div class="tw-bg-teal-600 tw-rounded-3 tw-h-12 tw-flex tw-items-center tw-justify-center tw-cursor-pointer"
             (click)="viewUpdatedTreatment()">
          <span class="tw-font-lexend tw-font-semibold tw-text-500 tw-text-white" i18n="@@viewUpdatedTreatment">
            View Updated Treatment
          </span>
        </div>
      </div>
    </div>
  </div>
}

} @else {
<div class="tw-bg-gray-100 tw-h-full tw-overflow-y-auto tw-pb-40">
  <ng-container *ngTemplateOutlet="headerTemplate; context: { $implicit: consentDoctorText }"></ng-container>

  <div class="tw-px-6 tw-pt-5 tw-flex tw-flex-col tw-gap-5 tw-items-center">
    <div class="tw-flex tw-flex-col tw-gap-2 tw-w-full">
      <p class="tw-text-200 tw-font-lexend tw-font-bold tw-text-gray-400 tw-tracking-wider" i18n="@@beforeYouStart">
        BEFORE YOU START
      </p>

      <div class="tw-flex tw-flex-col tw-gap-3">
        <!-- Card 1: Contraception -->
        <div class="tw-bg-gray-75 tw-rounded-3 tw-p-4 tw-flex tw-gap-3">
          <img src="/assets/icons/contraception-warning.svg" class="tw-h-8 tw-w-8 tw-shrink-0" alt="" />
          @if (gender === 'male') {
            <p class="tw-text-200 tw-font-body tw-text-gray-800">
              <span class="tw-font-bold" i18n="@@contraceptionMaleBold">Use contraception throughout your treatment.</span>
              <span i18n="@@contraceptionMaleRest"> Isotretinoin can cause birth defects - ensure your partner is protected if she could become pregnant.</span>
            </p>
          } @else {
            <p class="tw-text-200 tw-font-body tw-text-gray-800">
              <span class="tw-font-bold" i18n="@@contraceptionFemaleBold">Use contraception to avoid pregnancy during treatment</span>
              <span i18n="@@contraceptionFemaleRest"> and for at least 6 months after your last dose. Isotretinoin can cause birth defects.</span>
            </p>
          }
        </div>

        <!-- Card 2: Dryness -->
        <div class="tw-bg-gray-75 tw-rounded-3 tw-p-4 tw-flex tw-gap-3">
          <div class="tw-h-8 tw-w-8 tw-bg-teal-100 tw-rounded-1 tw-flex tw-items-center tw-justify-center tw-shrink-0">
            <img src="/assets/icons/dryness-warning.svg" class="tw-h-5 tw-w-5" alt="" />
          </div>
          <p class="tw-text-200 tw-font-body tw-text-gray-800">
            <span class="tw-font-bold" i18n="@@drynessBold">Dryness is expected.</span>
            <span i18n="@@drynessRest"> You will likely notice chapped lips, dry skin, and facial tightness. Use your moisturizer and lip balm daily.</span>
          </p>
        </div>

        <!-- Card 3: Mood swings -->
        <div class="tw-bg-gray-75 tw-rounded-3 tw-p-4 tw-flex tw-gap-3">
          <div class="tw-h-8 tw-w-8 tw-bg-teal-100 tw-rounded-1 tw-flex tw-items-center tw-justify-center tw-shrink-0">
            <img src="/assets/icons/mood-swings-warning.svg" class="tw-h-5 tw-w-5" alt="" />
          </div>
          <p class="tw-text-200 tw-font-body tw-text-gray-800">
            <span class="tw-font-bold" i18n="@@moodSwingsBold">Some people experience mood swings.</span>
            <span i18n="@@moodSwingsRest"> If you feel depressed or anxious, reach out to your doctor in the HELP section.</span>
          </p>
        </div>

        <!-- Card 4: Blood donation -->
        <div class="tw-bg-gray-75 tw-rounded-3 tw-p-4 tw-flex tw-gap-3">
          <div class="tw-h-8 tw-w-8 tw-bg-teal-100 tw-rounded-1 tw-flex tw-items-center tw-justify-center tw-shrink-0">
            <img src="/assets/icons/blood-donation-warning.svg" class="tw-h-5 tw-w-5" alt="" />
          </div>
          <p class="tw-text-200 tw-font-body tw-text-gray-800">
            <span class="tw-font-bold" i18n="@@bloodDonationBold">Do not donate blood during treatment</span>
            <span i18n="@@bloodDonationRest"> or for at least 1 month after your last dose.</span>
          </p>
        </div>

        <!-- Card 5: Liver issues -->
        <div class="tw-bg-gray-75 tw-rounded-3 tw-p-4 tw-flex tw-gap-3">
          <img src="/assets/icons/liver-warning.svg" class="tw-h-8 tw-w-8 tw-shrink-0" alt="" />
          <p class="tw-text-200 tw-font-body tw-text-gray-800">
            <span i18n="@@liverPrefix">Incase you have </span><span class="tw-font-bold" i18n="@@liverBold">known liver issues</span><span i18n="@@liverSuffix"> kindly let us know in the HELP section.</span>
          </p>
        </div>
      </div>
    </div>

    <p class="tw-text-200 tw-font-body tw-italic tw-text-gray-400 tw-text-center" i18n="@@consentDisclaimer">
      By confirming, you acknowledge that you've read and understood the information above about Isotretinoin treatment.
    </p>
  </div>
</div>

<div class="tw-fixed tw-bottom-0 tw-left-0 tw-w-full tw-bg-gray-75 tw-px-5 tw-py-6 tw-z-10">
  <div class="tw-flex tw-flex-col tw-gap-1">
    <div class="tw-bg-teal-600 tw-rounded-3 tw-h-12 tw-flex tw-items-center tw-justify-center tw-cursor-pointer"
         [class.tw-opacity-50]="loading"
         (click)="acceptAndConfirm()">
      <span class="tw-font-lexend tw-font-semibold tw-text-500 tw-text-white" i18n="@@acceptAndConfirm">
        Accept &amp; Confirm
      </span>
    </div>
    <div class="tw-h-12 tw-flex tw-items-center tw-justify-center tw-cursor-pointer" (click)="onNotSureClick()">
      <span class="tw-font-lexend tw-font-semibold tw-text-500 tw-text-teal-600" i18n="@@noNotSure">
        No, I'm Not Sure
      </span>
    </div>
  </div>
</div>

@if (showNotSurePopup) {
  <div class="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-end bg-dark-overlay" (click)="closeNotSurePopup()">
    <div
      class="tw-bg-gray-75 tw-rounded-t-6 tw-px-6 tw-py-9 tw-w-full tw-relative tw-flex tw-flex-col tw-gap-8"
      (click)="$event.stopPropagation()">

      <div
        class="tw-absolute tw-top-4 tw-right-4 tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center tw-cursor-pointer"
        (click)="closeNotSurePopup()">
        <cs-icon class="tw-h-5 tw-w-5 tw-text-gray-500" [iconName]="'close'"></cs-icon>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-4">
        <div class="tw-h-10 tw-w-10 tw-bg-teal-100 tw-rounded-2 tw-flex tw-items-center tw-justify-center">
          <cs-icon class="tw-h-6 tw-w-6 tw-text-teal-600" [iconName]="'call'"></cs-icon>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-1">
          <p class="tw-font-lexend tw-font-bold tw-text-600 tw-text-gray-800" i18n="@@wantToTalkTitle">
            Want to talk it through before you decide?
          </p>
          <p class="tw-font-body tw-font-medium tw-text-300 tw-text-gray-500" i18n="@@wantToTalkBody">
            Book a callback with skin advisor to discuss Isotretinoin, ask questions and decide what's right for you. Your order stays on hold until then.
          </p>
        </div>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-3">
        <div class="tw-bg-teal-600 tw-rounded-3 tw-h-12 tw-flex tw-items-center tw-justify-center tw-cursor-pointer"
             (click)="requestCall()">
          <span class="tw-font-lexend tw-font-semibold tw-text-500 tw-text-white" i18n="@@isotretinoinRequestACall">
            Request a Call
          </span>
        </div>

        <p class="tw-font-body tw-font-medium tw-text-300 tw-text-gray-500 tw-text-center" i18n="@@or">or</p>

        <div class="tw-flex tw-flex-col tw-gap-2 tw-items-center">
          <p class="tw-font-body tw-font-medium tw-text-300 tw-text-gray-500 tw-text-center" i18n="@@notComfortableQuestion">
            Not comfortable taking Isotretinoin?
          </p>
          <div class="tw-border tw-border-solid tw-border-teal-600 tw-rounded-3 tw-h-12 tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-w-full"
               (click)="removeIsotretinoin()">
            <span class="tw-font-lexend tw-font-semibold tw-text-500 tw-text-teal-600" i18n="@@removeIsotretinoin">
              Remove Isotretinoin
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (showCallScheduledPopup) {
  <div class="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-end bg-dark-overlay">
    <div
      class="tw-bg-gray-75 tw-rounded-t-6 tw-px-6 tw-py-9 tw-w-full tw-relative tw-flex tw-flex-col tw-gap-8"
      (click)="$event.stopPropagation()">

      <div
        class="tw-absolute tw-top-4 tw-right-4 tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center tw-cursor-pointer"
        (click)="goToHome()">
        <cs-icon class="tw-h-5 tw-w-5 tw-text-gray-500" [iconName]="'close'"></cs-icon>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-4">
        <img src="/assets/icons/teal-tick-circle.svg" class="tw-h-10 tw-w-10" alt="" />
        <div class="tw-flex tw-flex-col tw-gap-1">
          <p class="tw-font-lexend tw-font-bold tw-text-600 tw-text-gray-800" i18n="@@callScheduledTitle">
            Your call is scheduled
          </p>
          <p class="tw-font-body tw-font-medium tw-text-300 tw-text-gray-500">
            <span i18n="@@callScheduledBodyPrefix">Hi</span> {{ userName }}, <span i18n="@@callScheduledBodySuffix">we've scheduled a call with our skin advisor for you - feel free to ask any questions you have about Isotretinoin.</span>
          </p>
        </div>
      </div>

      <div class="tw-bg-teal-600 tw-rounded-3 tw-h-12 tw-flex tw-items-center tw-justify-center tw-cursor-pointer"
           (click)="goToHome()">
        <span class="tw-font-lexend tw-font-semibold tw-text-500 tw-text-white" i18n="@@isotretinoinCallScheduledOkay">
          Okay
        </span>
      </div>
    </div>
  </div>
}
}
